/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Dashboard_Detail_Section_UsageInputs */



/**
* | output |
* | --- |
* | "Credit & AI usage" |
*
* @param {Partner_Dashboard_Detail_Section_UsageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_dashboard_detail_section_usage = /** @type {((inputs?: Partner_Dashboard_Detail_Section_UsageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Dashboard_Detail_Section_UsageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Guthaben & KI-Nutzung")
	return /** @type {LocalizedString} */ ("Credit & AI usage")
});